import React from 'react';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import MailIcon from '@mui/icons-material/Mail';
import useIsAuthScreen from '../../hooks/useIsAuthScreen';

const Footer = props => {
    let {positionType} = props;
    const defaultPositionClasses = "relative mt-auto sm:fixed";
    const isAuthScreen = useIsAuthScreen();

    if (isAuthScreen) {
        return null;
    }

    return (
        <>
            <div className="clear-both h-[48px]"></div>
            <footer className={`w-full flex justify-between sm:bottom-0 ${positionType ? '' : defaultPositionClasses}`}>
                {/* <h6><PhoneAndroidIcon/><a href={"tel:+404-383-676"}>+404-383-676</a></h6> */}
                <h6><MailIcon/><a target={"_blank"} rel={"noreferrer"}
                                  href={"mailto:hello@siemba.io"}>hello@siemba.io</a>
                </h6>
                <h6 className={'sm:float-right'}>&copy; {new Date().getFullYear()} by Siemba Inc.</h6>
            </footer>
        </>
    );
};

// Footer.defaultProps = {
//     position: 'fixed',
// };


export default Footer;
